<template>
  <div class="bar">
    <el-tooltip
      effect="light"
      popper-class="tool-tooltip"
      content="仅测试流程执行人数结果，不会发送短信"
      placement="bottom"
    >
      <div
        :class="['bar-item', { disabled: statusNum != 0 && statusNum != 6 }]"
        @click="testMSG"
      >
        <img class="bar-item__icon" :src="imageCdn + '/test.svg'" alt="" />
        <span>测试执行</span>
      </div>
    </el-tooltip>
    <el-dropdown
      :disabled="sendDisabled"
      size="medium"
      placement="top-start"
      @command="sendCommand"
    >
      <div :class="['bar-item', 'bar-margin16', { disabled: sendDisabled }]">
        <div class="bar-item-wrap">
          <img class="bar-item__icon" :src="imageCdn + '/send.svg'" alt="" />
          <img class="bar-item__down" :src="imageCdn + '/down.svg'" alt="" />
        </div>
        <span class="bar-item__title">正式发送</span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="item in sendOptions"
          :key="item.value"
          :command="item.label"
          ><span> {{ item.label }}</span></el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    <el-tooltip
      effect="light"
      popper-class="tool-tooltip"
      content="恢复到设计中，同时取消还未发送的短信批次"
      placement="bottom"
    >
      <div :class="['bar-item', { disabled: resetDisabled }]" @click="reset">
        <img class="bar-item__icon" :src="imageCdn + '/edit.svg'" alt="" />
        <span>恢复设计</span>
      </div>
    </el-tooltip>
    <!-- 选择模式 -->
    <div class="bar-line"></div>
    <div class="mode">
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="拖动模式"
        placement="bottom"
      >
        <img
          :class="[
            'bar-column__icon',
            'bar-column__bottom',
            { disabled: operateDisabled },
            { 'selected-image': isImageSelected2 }, // 修改选中样式判断条件
            'hoverable-image' // 添加可悬浮样式类
          ]"
          :src="isImageSelected2? imageCdn + '/dragActive.png' :imageCdn + '/drag.svg'"
          alt=""
          @click="dragMode"
        />
      </el-tooltip>
      <span class="modeChild">
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="相交模式"
        placement="bottom"
      >
        <img
          :class="[
            'bar-column__icon',
            'bar-column__bottom',
            { disabled: operateDisabled },
            { 'selected-image': isImageSelected1 }, // 修改选中样式判断条件
            'hoverable-image' // 添加可悬浮样式类
          ]"
          :src="isImageSelected1?imageCdn + '/intersectActive.png' :imageCdn + '/intersect.svg'"
          alt=""
          @click="intersectionMode"
        />
      </el-tooltip>
      </span>
      <div class="modeChildOne" >选择模式</div>
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="包含模式"
        placement="bottom"
      >
        <img
          :class="[
            'bar-column__icon',
            'bar-column__bottom',
            { disabled: operateDisabled },
            { 'selected-image': isImageSelected }, // 修改选中样式判断条件
            'hoverable-image' // 添加可悬浮样式类
          ]"
          :src="isImageSelected?imageCdn + '/containActive.png' :imageCdn + '/contain.svg'"
          alt=""
          @click="includeMode"
        />
      </el-tooltip>
    </div>
    <div class="bar-line"></div>
     <!-- end -->
    <div class="bar-column bar-margin">
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="复制/粘贴（Ctrl+C/Ctrl+V）"
        placement="bottom"
      >
        <img
          :class="[
            'bar-column__icon',
            'bar-column__bottom',
            { disabled: operateDisabled },
          ]"
          :src="imageCdn + '/add.svg'"
          alt=""
          @click="copy"
        />
      </el-tooltip>
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="撤回（Ctrl+Z）"
        placement="bottom"
      >
        <img
          :class="['bar-column__icon', { disabled: operateDisabled }]"
          :src="imageCdn + '/revert.svg'"
          alt=""
          @click="revokeBtn"
        />
      </el-tooltip>
    </div>
    <!-- 操作 -->
    <div class="bar-column">
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="删除（Delete或Back Space）"
        placement="bottom"
      >
        <img
          :class="[
            'bar-column__icon',
            'bar-column__bottom',
            { disabled: operateDisabled },
          ]"
          :src="imageCdn + '/delete.svg'"
          alt=""
          @click="deleteOne"
        />
      </el-tooltip>
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="恢复（Ctrl+Y）"
        placement="bottom"
      >
        <img
          :class="['bar-column__icon', { disabled: operateDisabled }]"
          :src="imageCdn + '/redo.svg'"
          alt=""
          @click="redoBtn"
        />
      </el-tooltip>
    </div>
    <div class="bar-line"></div>
    <!-- 水平、垂直 -->
    <div class="bar-column bar-margin">
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="水平对齐"
        placement="bottom"
      >
        <img
          :class="[
            'bar-column__icon',
            'bar-column__bottom',
            { disabled: operateDisabled },
          ]"
          :src="imageCdn + '/center.svg'"
          alt=""
          @click="backout"
        />
      </el-tooltip>
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="垂直对齐"
        placement="bottom"
      >
        <img
          :class="['bar-column__icon', { disabled: operateDisabled }]"
          :src="imageCdn + '/align.svg'"
          alt=""
          @click="recover"
        />
      </el-tooltip>
    </div>
    <div class="bar-column">
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="自动布局"
        placement="bottom"
      >
        <div class="bar-column__row bar-column__item" @click="layout">
          <img class="bar-item__icon" :src="imageCdn + '/layout.svg'" alt="" />
          <span>自动布局</span>
        </div>
      </el-tooltip>
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        :content="gridVisible ? '隐藏网格' : '显示网格'"
        placement="bottom"
      >
        <div class="bar-column__row bar-column__item" @click="hideGrid">
          <img class="bar-item__icon" :src="imageCdn + '/hide.svg'" alt="" />
          <span>{{ gridVisible ? "隐藏网格" : "显示网格" }}</span>
        </div>
      </el-tooltip>
    </div>
    <div class="bar-line"></div>
    <el-tooltip
      v-if="hasReplace"
      effect="light"
      popper-class="tool-tooltip"
      :content="isCanFindReplace ? '批量替换画布里的短信文案' : noPowerText"
      placement="bottom"
    >
      <div :class="['bar-item bar-margin', { disabled: !isCanFindReplace }]" @click="replacement">
        <img class="bar-item__icon" :src="imageCdn + '/replace.svg'" alt="" />
        <span>查找替换</span>
      </div>
    </el-tooltip>
    <el-tooltip
      v-if="hasReplace"
      effect="light"
      popper-class="tool-tooltip"
      :content="isCanClickNaming ? '一键命名' : noPowerText"
      placement="bottom"
    >
      <div :class="['bar-item bar-margin', { disabled: !isCanClickNaming }]" @click="oneClickNaming">
        <img class="bar-item__icon" :src="imageCdn + '/name.svg'" alt="" />
        <span>一键命名</span>
      </div>
    </el-tooltip>
    <el-dropdown
      :disabled="operateDisabled"
      size="medium"
      placement="bottom"
      @command="setingMore"
    >
      <div :class="['bar-item', { disabled: operateDisabled }]">
        <div class="bar-item-wrap">
          <img class="bar-item__icon" :src="imageCdn + '/more.svg'" alt="" />
          <img class="bar-item__down" :src="imageCdn + '/down.svg'" alt="" />
        </div>
        <span class="bar-item__title">批量操作</span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-tooltip
          effect="light"
          popper-class="tool-tooltip"
          :content="isCanBatchIpdateWait ? '' : noPowerText"
          placement="top"
          :disabled="isCanBatchIpdateWait"
          :enterable="false"
        >
          <el-dropdown-item command="await">
            <span :class="['dropdown__title', { disabled: !isCanBatchIpdateWait }]"
            >批量编辑等待节点</span>
          </el-dropdown-item>
        </el-tooltip>
        <el-tooltip
          effect="light"
          popper-class="tool-tooltip"
          :content="isCanBatchIpdateSMS ? '' : noPowerText"
          placement="top"
          :disabled="isCanBatchIpdateSMS"
          :enterable="false"
        >
          <el-dropdown-item command="msg">
            <span :class="['dropdown__title', { disabled: !isCanBatchIpdateSMS }]"
            >批量编辑短信节点</span>
          </el-dropdown-item >
        </el-tooltip>
        <el-tooltip
          effect="light"
          popper-class="tool-tooltip"
          :content="isCanBatchIpdateTouch ? '' : noPowerText"
          placement="top"
          :disabled="isCanBatchIpdateTouch"
          :enterable="false"
        >
          <el-dropdown-item command="edit"
            ><span :class="['dropdown__title', { disabled: !isCanBatchIpdateTouch }]"
            >批量检查及修改触达节点</span>
          </el-dropdown-item>
        </el-tooltip>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="bar-line"></div>
    <el-tooltip
      effect="light"
      popper-class="tool-tooltip"
      content="画布配置"
      placement="bottom"
    >
      <div class="bar-item" @click="openQuick">
        <img class="bar-item__icon" :src="imageCdn + '/setting.svg'" alt="" />
        <span>画布配置</span>
      </div>
    </el-tooltip>
    <el-tooltip effect="light" popper-class="tool-tooltip" placement="bottom">
      <div slot="content" style="line-height: 20px; color: rgb(51, 51, 51)">
        <div>1. 复制/粘贴：Ctrl+C/Ctrl+V</div>
        <div>2. 删除：Delete或Back Space</div>
        <div>3. 多选节点：Ctrl+选中节点</div>
        <div>4. 多选内容：Ctrl+鼠标按住或鼠标按住</div>
        <div>5. 放大画布：Ctrl+鼠标滚轮↑</div>
        <div>6. 缩小画布：Ctrl+鼠标滚轮↓</div>
        <div>7. 撤回：Ctrl+Z</div>
        <div>8. 恢复：Ctrl+Y</div>
      </div>
      <div class="bar-item bar-quick bar-margin16">
        <img class="bar-item__icon" :src="imageCdn + '/quick.svg'" alt="" />
        <span>快捷引导</span>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    statusNum: {
      type: [String, Number],
      default: "",
    },
    sendOptions: {
      type: Array,
      default: () => [],
    },
    openSend: {
      type: Boolean,
      default: false,
    },
    gridVisible: {
      type: Boolean,
      default: false,
    },
    hasReplace: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isImageSelected: true, // 初始时没有图片被选中
      isImageSelected1: false, // 初始时没有图片被选中
      isImageSelected2: false, // 初始时没有图片被选中
      imageCdn:
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/intelligent/tools",
      noPowerText: "使用该功能需开通云舟专业版/数智版，请联系您的专属客服处理哦~",
    };
  },
  computed: {
    // 正式发送
    sendDisabled() {
      return this.statusNum != 4 && this.statusNum != 6 && !this.openSend;
    },
    // 恢复设计
    resetDisabled() {
      return this.statusNum == 0 || this.statusNum == 2;
    },
    // 复制、删除、撤销、重做、水平、垂直
    operateDisabled() {
      return this.statusNum != 0 && this.statusNum != 6;
    },
    // 以下为权限位判断
    // 一键命名
    isCanClickNaming() {
      const permissions = this.$store.getters.loginUserInfo.permissions;
      let isCan = permissions.includes("intelligent_marketing:canvas:auto_naming");
      return isCan;
    },
    // 查找替换
    isCanFindReplace() {
      const permissions = this.$store.getters.loginUserInfo.permissions;
      let isCan = permissions.includes("intelligent_marketing:canvas:find_replace");
      return isCan;
    },
    // 更新节点名称
    isCanUpdateNodeName() {
      const permissions = this.$store.getters.loginUserInfo.permissions;
      let isCan = permissions.includes("intelligent_marketing:canvas:node_rename");
      return isCan;
    },
    // 批量编辑等待节点
    isCanBatchIpdateWait() {
      const permissions = this.$store.getters.loginUserInfo.permissions;
      let isCan = permissions.includes("intelligent_marketing:canvas:batch_edit_wait");
      return isCan;
    },
    // 批量编辑短信节点
    isCanBatchIpdateSMS() {
      const permissions = this.$store.getters.loginUserInfo.permissions;
      let isCan = permissions.includes("intelligent_marketing:canvas:batch_edit_sms");
      return isCan;
    },
    // 批量检查及修改触达节点
    isCanBatchIpdateTouch() {
      const permissions = this.$store.getters.loginUserInfo.permissions;
      let isCan = permissions.includes("intelligent_marketing:canvas:batch_check_and_update_touch");
      return isCan;
    },
  },
  methods: {
    // 包含
    includeMode(){
      this.isImageSelected = !this.isImageSelected; // 切换选中状态
      this.isImageSelected1 = false;
      this.isImageSelected2 = false;
      this.$emit("includeMode");
    },
    // 相交
    intersectionMode(){
      this.isImageSelected1 = !this.isImageSelected1; // 切换选中状态
      this.isImageSelected = false;
      this.isImageSelected2 = false;
      this.$emit("intersectionMode");
    },
    // 拖动  
    dragMode(){
      this.isImageSelected2 = !this.isImageSelected2; // 切换选中状态
      this.isImageSelected = false;
      this.isImageSelected1 = false;
      this.$emit("dragMode");
    },
    // 测试执行
    testMSG() {
      if (this.statusNum != 0 && this.statusNum != 6) return;
      this.$emit("testMSG");
    },
    // 正式发送
    sendCommand(val) {
      this.$emit("sendCommand", val);
    },
    // 恢复设计
    reset() {
      this.$emit("reset");
    },
    // 复制
    copy() {
      if (this.operateDisabled) return;
      this.$emit("copy");
    },
    // 删除
    deleteOne() {
      if (this.operateDisabled) return;
      this.$emit("deleteOne");
    },
    // 撤销
    revokeBtn() {
      if (this.operateDisabled) return;
      this.$emit("revokeBtn");
    },
    // 重做
    redoBtn() {
      if (this.operateDisabled) return;
      this.$emit("redoBtn");
    },
    // 水平
    backout() {
      if (this.operateDisabled) return;
      this.$emit("backout");
    },
    // 垂直
    recover() {
      if (this.operateDisabled) return;
      this.$emit("recover");
    },
    // 自动布局
    layout() {
      this.$emit("layout");
    },
    // 隐藏网格
    hideGrid() {
      this.$emit("hideGrid");
    },
    // 一键替换文案
    replacement() {
      if(!this.isCanFindReplace) return;
      this.$emit("replacement");
    },
    // 一键命名
    oneClickNaming() {
      if(!this.isCanClickNaming) return;
      this.$emit("oneClickNaming");
    },
    // 批量操作
    setingMore(val) {
      if(val == 'await' && !this.isCanBatchIpdateWait) return;
      if(val == 'msg' && !this.isCanBatchIpdateSMS) return;
      if(val == 'edit' && !this.isCanBatchIpdateTouch) return;
      this.$emit("setingMore", val);
    },
    // 画布配置
    openQuick() {
      this.$emit("openQuick");
    },
  },
};
</script>

<style lang="scss">
/* 使用全局样式而非scoped，确保能覆盖element-ui内部样式 */
.tool-tooltip {
  color: #4f4f4f !important;
  z-index: 20000 !important;
}

/* 针对element-ui的popper容器直接设置高z-index */
.el-dropdown-menu .el-tooltip {
  z-index: 20000 !important;
}

.el-dropdown-menu .el-popper {
  z-index: 20000 !important;
}

/* 确保tooltip的popper内容也能正确显示 */
.el-tooltip__popper {
  z-index: 20000 !important;
}

/* 特别是针对嵌套在dropdown中的tooltip */
.el-dropdown-menu .el-tooltip__popper {
  z-index: 20000 !important;
}
</style>

<style lang="scss" scoped>
.bar {
  display: flex;
  align-items: center;
  font-size: 12px;
  border-top: 1px solid #f3f3f3;
  border-bottom: 1px solid #f3f3f3;
  color: #4f4f4f;
  padding: 8px 0px;
  &-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding: 4px;
    &:hover {
      border-radius: 2px;
      background-color: #f2f4f9;
    }
    &__title {
      font-size: 12px;
      color: #4f4f4f;
    }
    &__icon {
      width: 20px;
      height: 20px;
    }
    &__down {
      width: 12px;
      height: 12px;
    }
    &-wrap {
      display: flex;
      align-items: center;
    }
  }
  &-quick {
    cursor: default;
  }
  &-line {
    height: 20px;
    width: 1px;
    background-color: #e6e6e6;
    margin: 0px 16px;
  }
  &-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    &__bottom {
      margin-bottom: 6px;
    }
    &__icon {
      width: 20px;
      height: 20px;
      cursor: pointer;
      &:hover {
        border-radius: 2px;
        background-color: #f2f4f9;
      }
    }
    &__row {
      display: flex;
      align-items: center;
    }
    &__item {
      cursor: pointer;
      padding: 4px;
      &:hover {
        border-radius: 2px;
        background-color: #f2f4f9;
      }
    }
  }
  &-margin16 {
    margin: 0px 12px;
  }
  &-margin {
    margin-right: 12px;
  }
}
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  user-select: none;
  &:hover {
    background-color: transparent;
  }
}
.dropdown__title {
  font-size: 12px;
  color: #333333;
}
.mode{
    margin-top: -15px;
    .modeChild{
      margin: 0 16px 0 16px;
    }
    .modeChildOne{
      position: absolute;
      top: 97px;
      left: 265px;
      font-size: 12px;
      color:#4F4F4F;
    }
}
//选中样式的处理
.selected-image {
  background-color: #f2f4f9;
}

// 添加未选中时悬浮显示灰色底色的样式
.hoverable-image:not(.selected-image):not(.disabled):hover {
  border-radius: 2px;
  background-color: #f2f4f9;
}

// 调整选中样式，移除背景色设置
.selected-image {
  border-radius: 2px;
  /* 移除背景色，避免选中时显示灰色底色 */
  background-color: transparent; 
}
</style>
